import React from "react";
import type { SettingItemSliderModel } from "../../type/toggleControl";
import "./settingItemSlider.scss";

const SettingItemSlider: React.FC<SettingItemSliderModel> = ({
  label,
  description,
  value,
  options = ["A1", "A2", "B1", "B2", "C1"],
  onChange,
  saving = false,
  variant = "slider",
  className = ""
}) => {
  const variantClass = variant === "compact" ? "setting-toggle-item-compact" : "setting-toggle-item-slider";

  return (
    <div className={`setting-toggle-item ${variantClass} ${className}`.trim()}>
      <div className="setting-toggle-item-info">
        <div className="setting-toggle-item-label">{label}</div>
        <div className="setting-toggle-item-description">{description}</div>
      </div>
      <div className="language-level-slider">
        {options.map((option) => (
          <button
            key={option}
            className={`level-button ${value === option ? "active" : ""} ${saving ? "saving" : ""}`}
            onClick={() => onChange(option)}
            disabled={saving}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SettingItemSlider;